module.exports = __webpack_public_path__ + "media/images/emoticons/bullettrain-b03f298b070f8d3efa76c8e2f2bfd8ae.gif";